import { get, upperFirst } from "lodash";
import styled from "styled-components";
import React from "react";
import { A, IconLinkedIn, IconTwitter, H5, P } from "@upsolve/ui";

import ImageInContext from "../Media/ImageInContext";

const MAX_BIO_LENGTH = 280;

const AuthorBioWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin: 0.5em 0;
  box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.1);
  padding: 1em;
  border-radius: 6px;

  .author-image__image,
  img {
    height: 96px;
    width: 96px;
    min-height: 96px;
    min-width: 96px;
    border-radius: 48px;
  }

  .author-image {
    margin: 0 0.5em;
  }

  .author-bio {
    padding: 1em 0.5em;
    p {
      margin: 0.25em 0;
    }
    h5 {
      margin: 0;
      a.icons {
        display: flex;
        font-size: 0;
      }
    }
    small {
      margin: 0 0.25em;
    }
    .icons {
      display: flex;
      .icon {
        margin-right: 12px;
        font-size: 0;
      }
    }
    p.about {
      font-size: 15px;
    }
    svg {
      height: 16px;
      max-height: 16px;
      width: 16px;
      max-width: 16px;
      path {
        fill: ${(props) => props.theme.colors.brand[500]};
      }
    }
  }

  @media (max-width: 45em) {
    flex-direction: column;
    align-items: flex-start;
    margin: 1.5em 0;
    h5 {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      span {
        margin: 0.75em 0 0.5em;
      }
    }
  }
`;

const AuthorBio = ({ author }) => {
  const profiles = author.profiles || [];
  return (
    <AuthorBioWrapper>
      <div className="author-image">
        <ImageInContext
          className="author-image__image"
          alt={get(author, "name", "")}
          src={get(author, "image.image.file.url")}
          fluid={get(author, "image.image.fluid")}
        />
      </div>
      <div className="author-bio">
        <H5 as="p">
          <A aria-busy="false" href={`/authors/${author.slug}/`}>
            {upperFirst(author.name)}
          </A>
        </H5>
        <span className="icons">
          {profiles.some((p) => /Twitter/i.test(p.label)) && (
            <A
              className="icon"
              href={profiles.find((p) => /Twitter/i.test(p.label)).url}
              target="_blank"
              rel="noopener noreferrer"
            >
              Twitter
              <IconTwitter />
            </A>
          )}
          {profiles.some((p) => /LinkedIn/i.test(p.label)) && (
            <A
              className="icon"
              href={profiles.find((p) => /LinkedIn/i.test(p.label)).url}
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
              <IconLinkedIn />
            </A>
          )}
        </span>
        <P className="about">
          {!!get(author, "biography.biography") && author.biography.biography.length > MAX_BIO_LENGTH ? (
            <span>
              {`${author.biography.biography.slice(0, MAX_BIO_LENGTH).trim()}...`}
              <A aria-busy="false" href={`/authors/${author.slug}/`}>
                {" "}
                read more about {upperFirst(author.name)}
              </A>
            </span>
          ) : (
            get(author, "biography.biography", "")
          )}
        </P>
      </div>
    </AuthorBioWrapper>
  );
};

export default AuthorBio;
